import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { getSEOTags, generateStructuredData } from '../utils/seoConfig';

const SEOHead = ({ customSEO = {}, structuredData = {} }) => {
  const location = useLocation();
  const pageKey = location?.pathname;
  
  const seoTags = getSEOTags(pageKey, customSEO);
  const jsonLd = generateStructuredData(pageKey, structuredData);

  return (
    <Helmet>
      <title>{seoTags?.title}</title>
      {seoTags?.meta?.map((tag, index) => (
        tag?.name ? (
          <meta key={index} name={tag?.name} content={tag?.content} />
        ) : (
          <meta key={index} property={tag?.property} content={tag?.content} />
        )
      ))}
      {seoTags?.link?.map((tag, index) => (
        <link key={index} rel={tag?.rel} href={tag?.href} />
      ))}
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
};

export default SEOHead;